module.exports = __webpack_public_path__ + "img/British Indian OceanTerritory.b9d0c2ff.svg";